import { render, staticRenderFns } from "./details-left-picture.vue?vue&type=template&id=598e6d6b&scoped=true&"
import script from "./details-left-picture.vue?vue&type=script&lang=ts&"
export * from "./details-left-picture.vue?vue&type=script&lang=ts&"
import style0 from "./details-left-picture.vue?vue&type=style&index=0&id=598e6d6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598e6d6b",
  null
  
)

export default component.exports